import { WorkflowEditPage } from "@/pages/workflows/edit/WorkflowEditPage.tsx";
import { WorkflowNewPage } from "@/pages/workflows/edit/WorkflowNewPage.tsx";
import { WorkflowSummaryPage } from "@/pages/workflows/view/WorkflowSummaryPage.tsx";
import { WorkflowExecutionDetailsPage } from "@/pages/workflows/WorkflowExecutionDetailsPage.tsx";
import { WorkflowLibrary } from "@/pages/workflows/WorkflowLibrary.tsx";
import { WorkflowOverview } from "@/pages/workflows/WorkflowOverview.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const workflowRoutes: RouteConfig[] = [
  {
    path: "workflows",
    planFeature: ApiFeatureType.workflows,
    allOfPermissions: [ApiPermission.workflow_module],
    children: [
      {
        path: "",
        element: <WorkflowLibrary />,
      },
      {
        path: "executions",
        element: <WorkflowOverview />,
      },
      {
        // TODO(2026-05-06): Remove legacy /workflows/overview route after users refresh cached clients.
        path: "overview",
        element: <WorkflowOverview />,
      },
      {
        path: "executions/:executionId",
        element: <WorkflowExecutionDetailsPage />,
      },
      {
        path: "new",
        element: <WorkflowNewPage />,
        isFullScreen: true,
      },
      {
        path: "library",
        element: <WorkflowLibrary />,
      },
      {
        path: "library/:id",
        element: <WorkflowLibrary />,
      },
      {
        path: ":id/setup/:step?",
        element: <WorkflowEditPage />,
        isFullScreen: true,
      },
      {
        path: ":id/summary",
        element: <WorkflowSummaryPage />,
      },
    ],
  },
];
